import gql from 'graphql-tag';

export const getModels = gql`
  query {
    getModels {
      modelId
      name
		  type
      distance
      remark
      code
		  image {
        url
      }
      meshElements {
        meshElementId
        name
        location
        meshModels
      }
    }
  }
`
